import axios from 'axios';
import refreshAttribute from '../utils/refreshAttribute';

export default {
  name: 'video-modal-manager',

  events: [
    {
      on: 'click',
      handle (e) {
        e.preventDefault();
        if (!this.el.getAttribute('js-modal-control')) {
          this.request();
        }
      },
    },
  ],

  componentDidMount () {
    this.modalID = this.id = this.props.id;
    this.id = this.props.id;
    this.src = this.props.src;
    this.poster = this.props.poster;
    this.titre = this.props.titre;
  },
 
  request () {
    this.createModal(`
      <div class="video-modal__wrapper w-full flex items-center">
        <button type="button" class="modal__close-button modal__close-button--white z-1" js-modal-close>
          <svg width="64" height="48" class="icon icon--night-blue" style="fill: #fff;">
            <use href="#icon-close" xlink:href="#icon-close"></use>
          </svg>
        </button>
        <div class="relative w-full">
          <div class="video video_portrait" js-video-player="{type: 'wordpress'}">
            <video autoplay muted js-video-player-video controls src="${this.src}"></video>
            <!--div js-video-player-overlay class="video__overlay flex lazyload" data-bg="${this.poster}">
              <div class="video__overlay__infos">
                <button>
                  <svg width="19" height="22" class="icon icon--stroke--white" aria-hidden="true">
                    <use href="#icon-play" xlink:href="#icon-play"></use>
                  </svg>
                </button>
                <div class="text-white title title--S font-weight-light mb-2 mt-4">${this.titre}</div>
              </div>
            </div-->
          </div>
        </div>
      </div>
    `);
  },



  createModal (data) {
    const node = document.createElement('div');
    node.classList.add('modal', 'video-modal', 'is-hidden');
    node.id = `video-modal-${this.modalID}`;
    node.setAttribute('js-modal', '');

    // node.appendChild(stringToHTML(data))
    node.innerHTML = data;
    this.el.setAttribute(
      'js-modal-control',
      `{'target': '#video-modal-${this.modalID}'}`,
    );
    node.setAttribute('js-modal-video', '');
    document.querySelector('.modals').appendChild(node);
    refreshAttribute('js-video-player')(node.querySelector('.video'));

    setTimeout(() => {
      this.el.click();
    }, 300);
  },
};
